import EmptyState from '@atlaskit/empty-state';
import { messages } from '@databases/intl/messages';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

import genericErrorIllustration from '../../assets/generic_error.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;

  > * {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    min-height: 0;

    > img {
      flex-basis: 0;
    }
  }
`;

interface GenericErrorStateProps {
  message?: string;
}

/**
 * A modified version of EmptyState that uses flexbox so that it can shrink in case it is too big for the screen.
 */
const GenericErrorState: FunctionComponent<GenericErrorStateProps> = (props) => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper>
      <EmptyState
        header={formatMessage(messages['generic-error.header'])}
        description={props.message}
        imageUrl={genericErrorIllustration}
        maxImageWidth={300}
        maxImageHeight={250}
      />
    </Wrapper>
  );
};

export default GenericErrorState;
